module.exports = __webpack_public_path__ + "media/img/contact-us/offices/flag-ukraine-3c282a2015d369d988b52228dc36ca5e.png";